/* =====================================================================
   Contact : pre-remplissage depuis les parametres d'URL

   Les fiches en « production sur demande » (tag produit `sur-demande`, cf.
   snippets/product-sur-demande.liquid) envoient vers
   /pages/contact?sujet=devis&produit=<handle>[&reference=<sku>].
   Sans ce pre-remplissage, la demande arrive sans indication du produit et le
   devis demande un aller-retour de plus.

   Pose l'objet du formulaire et amorce le message. L'utilisateur reste libre de
   tout modifier : on n'ecrase jamais un champ que le visiteur a deja rempli.
   ===================================================================== */

(function () {
  'use strict';

  /* Libelles : snippets/i18n-js.liquid (window.FOG_I18N, charge avant ce script
     par layout/theme.liquid). Lu a l'appel, jamais en dur. Spec 07. */
  function i18n(cle, vars) {
    return window.FOG_I18N.t(cle, vars);
  }

  var params;
  try {
    params = new URLSearchParams(window.location.search);
  } catch (e) {
    return;
  }
  if (params.get('sujet') !== 'devis') return;

  var produit = params.get('produit') || '';
  var reference = params.get('reference') || '';
  if (!produit) return;

  // handle -> libelle lisible : "fog-x-grow-bar-601" devient "Fog x grow bar 601"
  var libelle = produit.replace(/-/g, ' ').trim();
  libelle = libelle.charAt(0).toUpperCase() + libelle.slice(1);

  var objet = document.getElementById('ContactForm-subject');
  if (objet && !objet.value) {
    var cible = Array.prototype.find.call(objet.options, function (o) {
      // Valeur envoyee au serveur, restee en francais (seul le libelle est traduit)
      return o.value === 'Renseignement produit';
    });
    if (cible) objet.value = cible.value;
  }

  var message = document.getElementById('ContactForm-message');
  if (message && !message.value.trim()) {
    var produitLibelle = libelle
      + (reference ? ' ' + i18n('pages.contact.prefill_reference', { reference: reference }) : '');
    message.value = i18n('pages.contact.prefill_message', { product: produitLibelle });
  }
})();
